import {
	SET_ACTIVE_PROMO,
} from '../actions/activePromoActions'

const initialState = {
}

export default function activePromoReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_PROMO:
			// Select activeRoom manually
			return {
				...state,
				activePromo: action.payload,
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activePromoReducers.js